import nodeAxios from 'axios'

const axios = nodeAxios.create({
  baseURL: window.location.origin,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

const updateAcceptLanguageHeader = (): void => {
  axios.defaults.headers.common['Accept-Language'] = i18n.language
}

i18n.on('languageChanged', async (): Promise<void> => {
  updateAcceptLanguageHeader()
})

updateAcceptLanguageHeader()

export const setupPandaAxiosInterceptors = (
  pandaHandler: (panda: boolean) => Promise<void>,
): void => {
  axios.interceptors.response.use(
    (response) => {
      pandaHandler(Boolean(response.headers['X-Original-User-ID']))

      return response
    },
    (error) => {
      return Promise.reject(error)
    },
  )
}

export default axios
